import React, { Component } from 'react';
import { Container } from 'reactstrap';
import i18n from '../i18next';

class PageNotFoundScreen extends Component {
    render() {
        const { errorMessageContainer } = styles;

        return (
            <Container>
                <h3 style={errorMessageContainer}>
                    {i18n.t('screens:pageNotFound.pageNotFound')}
                </h3>
            </Container>
        );
    }
}

export default PageNotFoundScreen;

let styles = {
    errorMessageContainer: {
		textAlign: 'center',
		marginTop: 100
	}
}


// WEBPACK FOOTER //
// ./src/components/PageNotFoundScreen.js